<!--合作伙伴-->
<template>
  <div class="cplist">
    <li v-for="(item, index) in data" :key="index">
      <div><img :src="item.url"></div>
    </li>
  </div>
</template>

<script>
import api from '@/apis/CompanyProfile'
export default {
  data() {
    return {
      data: [
        { id: 0, url:require('@/assets/images/pic2.png')},
        { id: 1, url:require('@/assets/images/pic3.png')},
        { id: 2, url:require('@/assets/images/pic3.png')},
        { id: 3, url:require('@/assets/images/pic2.png')},
        { id: 4, url:require('@/assets/images/pic3.png')},
        { id: 5, url:require('@/assets/images/pic2.png')},
        { id: 6, url:require('@/assets/images/pic3.png')},
        { id: 7, url:require('@/assets/images/pic2.png')},
      ],
    };
  },
  methods: {

  },
  mounted() {
    api
      .partner({
        params: {
          limit: 20,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          this.data= res.data.list
        } else {
          this.$message.error(res.message)
        }
      })    
  },
};
</script>

<style lang="less" scoped>
.cplist{ padding:.4rem; height: 100%; overflow-y: auto; display: flex; flex-direction: row; flex-wrap: wrap;
  li{ height: 50%; width: 25%; padding: .3rem;
    &>div{ background: #fff; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;
      img{ width: 100%; display: block;}
    }
  }
}
</style>